module.exports = __webpack_public_path__ + "static/media/pollution.6b5d84fb.jpg";